import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttendancesOnEventTypesStatisticComponent } from './attendances-on-event-types-statistic.component';
import { IonicModule } from '@ionic/angular';
import { StatisticComponentModule } from '../../statistic-component/statistic.component.module';
import { TranslationModule } from '@app/app-translation.module';

@NgModule({
	declarations: [AttendancesOnEventTypesStatisticComponent],
	exports: [AttendancesOnEventTypesStatisticComponent],
	imports: [CommonModule, IonicModule, TranslationModule, StatisticComponentModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AttendancesOnEventTypesStatisticComponentModule {}
